var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3167 10C20.3167 15.52 15.8267 20 10.3167 20L10.0369 19.9962C4.64607 19.8478 0.31665 15.4264 0.31665 10C0.31665 4.49 4.79665 0 10.3167 0C15.8267 0 20.3167 4.49 20.3167 10ZM8.33665 6C8.04665 6.3 8.04665 6.77 8.34665 7.06L11.2967 10L8.34665 12.94C8.04665 13.23 8.04665 13.71 8.33665 14C8.63665 14.3 9.10665 14.3 9.39665 14L12.8867 10.53C13.0267 10.39 13.1067 10.2 13.1067 10C13.1067 9.8 13.0267 9.61 12.8867 9.47L9.39665 6C9.25665 5.85 9.06665 5.78 8.87665 5.78C8.67665 5.78 8.48665 5.85 8.33665 6Z",
    fill: "#26CD9F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight2);
export default __webpack_public_path__ + "static/media/ArrowRight2.aff9810e29f24108a77de6f7ec186825.svg";
export { ForwardRef as ReactComponent };